export const XLSX_HEADLINES = [
  "Date applied",
  "Email",
  "Name",
  "Phone",
  "Gender",
  "Diet",
  "Programme",
  "Year",
  "Free text",
  "Attended",
];
